export default __webpack_public_path__ + "static/media/1.4eda8934.jpeg";